import React from 'react';
import css from './DotSpinner.module.css';

export default class DotSpinner extends React.Component {
  render() {
    return (
      <div className={css.loader}>
        <span></span>
        <span></span>
        <span></span>
      </div>
    );
  }
}
